import { App, URLOpenListener } from "@capacitor/app";

export function subscribeToAppUrlOpen(listener: URLOpenListener) {
  return App.addListener("appUrlOpen", listener);
}
